import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { ZoomIn, Download } from "lucide-react";

export function ZoomableImage({ src, alt }) {
  const [open, setOpen] = useState(false);
  const filename = (src || "immagine").split("/").pop().split("?")[0] || "immagine";

  const scarica = async () => {
    try {
      const res = await fetch(src);
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch {
      window.open(src, "_blank", "noopener");
    }
  };

  return (
    <>
      <figure className="my-6" data-testid="zoomable-image">
        <button
          type="button"
          onClick={() => setOpen(true)}
          data-testid="zoomable-image-trigger"
          aria-label="Ingrandisci l'immagine"
          className="group relative block w-full cursor-zoom-in select-none rounded-md focus:outline-none focus:ring-2 focus:ring-primary/50"
        >
          <img
            src={src}
            alt={alt}
            draggable={false}
            className="w-full h-auto rounded-md border border-border shadow-[0_10px_30px_-12px_rgba(0,0,0,0.25)]"
          />
          <span className="pointer-events-none absolute bottom-3 right-3 inline-flex items-center gap-1.5 rounded-full bg-background/85 backdrop-blur px-3 py-1.5 text-xs font-medium text-foreground border border-border opacity-0 group-hover:opacity-100 transition-opacity">
            <ZoomIn className="h-3.5 w-3.5" strokeWidth={2} /> Clicca per ingrandire
          </span>
        </button>
      </figure>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          className="max-w-[96vw] sm:max-w-5xl p-0 overflow-hidden gap-0"
          data-testid="zoomable-image-dialog"
        >
          <DialogTitle className="sr-only">{alt || "Immagine ingrandita"}</DialogTitle>
          <div className="flex items-center justify-end gap-2 p-3 pr-14 border-b border-border">
            <Button
              variant="outline"
              size="sm"
              className="rounded-sm"
              onClick={scarica}
              data-testid="zoomable-image-download"
            >
              <Download className="h-4 w-4 mr-1.5" strokeWidth={2} /> Scarica
            </Button>
          </div>
          <div className="overflow-auto max-h-[82vh] bg-[#f4f1ea] p-2">
            <img src={src} alt={alt} className="w-full h-auto" />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
